import React from 'react';

import { createStylesHook } from 'shared/hooks/createStylesHook';
import { generateColorAndTextIndicator, StatusIndicatorAvailableStatus } from 'shared/utils';

const useStyles = createStylesHook({
  container: {
    alignItems: 'center',
    display: 'flex',
    position: 'relative'
  },

  circleIndicator: {
    borderRadius: '50%',
    display: 'block',
    height: '.4rem',
    position: 'absolute',
    width: '.4rem'
  },

  text: {
    display: 'block',
    margin: '0 0 0 .75rem'
  }
});

interface StatusIndicatorProps {
  status: StatusIndicatorAvailableStatus;
}

export const StatusIndicator: React.FunctionComponent<StatusIndicatorProps> = ({ status }) => {
  /**
   * Styles
   */
  const classes = useStyles();

  const { color, text } = generateColorAndTextIndicator(status);

  return (
    <div className={classes.container}>
      <i className={classes.circleIndicator} style={{ background: color }} />
      <span className={classes.text}>{text}</span>
    </div>
  );
};
